import {
  TweenLite,
  ScrollToPlugin,
  CSSPlugin,

  // easing
  Ease,
  Power0,
  Power1,
  Power2,
  Power3,
  Power4,
  Linear,
  Back,
  Elastic,
  Bounce,
  RoughEase,
  SlowMo,
  SteppedEase,
  Circ,
  Expo,
  Sine,
  ExpoScaleEase

} from 'gsap/all'

// Ensure modules don't get dropped by tree-shaking
const gsap = [
  TweenLite,
  ScrollToPlugin,
  CSSPlugin,

  // easing
  Ease,
  Power0,
  Power1,
  Power2,
  Power3,
  Power4,
  Linear,
  Back,
  Elastic,
  Bounce,
  RoughEase,
  SlowMo,
  SteppedEase,
  Circ,
  Expo,
  Sine,
  ExpoScaleEase

]

export default gsap
